// Прогрев кэша игрового контента (атлас + сцены доски/боя + UI-картинки), чтобы старт партии и первого
// боя был мгновенным. Грузим через fetch со стримингом → байтовый прогресс для полосы загрузки; ассеты
// оседают в HTTP-кэше браузера, и PIXI.Assets.load / <img> на старте берут их оттуда (без сети).
// Только для веб-клиента. figures/*.png НЕ грузим вообще: на доске фигуры в атласе (Pixi), а окно
// превращения пешки теперь рисует фигуру кропом из atlas.png (promoStyle в PagePlayWeb) — тот же атлас.

// Картинки ЛОББИ (src/assets) — webpack хеширует имена, поэтому импортируем, чтобы получить готовые URL.
// Берём только реально используемые экраны лобби (loader.png/logo.png не используются — не тащим).
import bg from './assets/bg.webp';
import menuWrapper from './assets/menu_wrapper.webp';
import cardLandscape from './assets/card-landscape.webp';
import category from './assets/category.webp';
import button from './assets/button.webp';
import zombie from './assets/zombie.webp';
import elf from './assets/elf.webp';
import radio from './assets/radio.webp';
import zombElf from './assets/ZombElf06.webp';
import chain from './assets/chain.webp';
import profileBorder from './assets/profile_border.webp';
import profiletile from './assets/profiletile.webp';
import facering from './assets/facering.webp';
import proflieCard from './assets/proflie-card.webp';
import proflieWallet from './assets/proflie-wallet.webp';
import inputbg from './assets/inputbg.webp';

const LOBBY_ASSETS = [
  bg, menuWrapper, cardLandscape, category, button, zombie, elf, radio,
  zombElf, chain, profileBorder, profiletile, facering, proflieCard, proflieWallet, inputbg,
].filter((u) => typeof u === 'string' && !u.startsWith('data:')); // мелкие assets могут быть инлайн data-URI

const FRAC = ['elf', 'zombie'];
const BTN = ['pack', 'paper', 'screen', 'sword'];
const BTN_STATE = ['active', 'disable'];
const WIN = ['equipment', 'equipmentEmpty', 'smallChess', 'smallEmpty'];

function uiList() {
  // ПРОГРЕВАЕМ только UI-арты, которых НЕТ в атласе: кнопки рамки и фоны окон. Мини-фигуры (mini_*),
  // подсветка клеток (cell*) и иконки классов (icon_*) лежат в atlas.webp и берутся ОТТУДА (доска/мини-доска
  // рисуют их кропом) — отдельные webp не качаем, иначе дублируем уже прогретый атлас.
  const ui = [];
  for (const b of BTN) for (const s of BTN_STATE) for (const f of FRAC) ui.push(`btn_${b}_${s}_${f}`);
  for (const w of WIN) for (const f of FRAC) ui.push(`win_${w}_${f}`);
  ui.push('backActive');
  return ui.map((n) => `/game/ui/${n}.webp`);
}

// порядок: лобби (видно сразу) → критичное игровое (атлас + фоны досок + UI) → боевые сцены последними.
// figures/*.png НЕ грузим: фигуры в атласе (доска), а окно превращения пешки рисует их кропом из atlas.png.
export const GAME_ASSETS = [
  ...LOBBY_ASSETS,
  '/game/atlas.json',
  '/game/atlas.webp', // все тяжёлые арты — WebP q95 (scripts/optimize-assets.js): ~21МБ PNG → ~4.5МБ
  '/game/boards/elf.webp', '/game/boards/zombie.webp',
  '/game/boards/elf_frame.webp', '/game/boards/zombie_frame.webp',
  ...uiList(),
  '/game/battle/cell_elf_black.webp', '/game/battle/cell_elf_white.webp',
  '/game/battle/cell_zombie_black.webp', '/game/battle/cell_zombie_white.webp',
];

const EST = 200 * 1024; // грубая оценка размера, если сервер не вернул Content-Length

// Загрузить все игровые ассеты в кэш. onProgress(fraction 0..1) — для полосы (можно null для фона).
// priority — хинт приоритета сети ('low' для фоновой загрузки в лобби, 'high' для полосы после логина).
// Никогда не падает: ошибка отдельного файла = считаем его «загруженным», прогресс не застревает.
export async function preloadAssets(onProgress, priority = 'auto') {
  const loaded = new Array(GAME_ASSETS.length).fill(0);
  const total = new Array(GAME_ASSETS.length).fill(0);
  const report = () => {
    if (!onProgress) return;
    const t = total.reduce((a, b) => a + (b || EST), 0) || 1;
    const l = loaded.reduce((a, b) => a + b, 0);
    onProgress(Math.min(1, l / t));
  };
  await Promise.all(GAME_ASSETS.map(async (url, i) => {
    try {
      const resp = await fetch(url, { priority, cache: 'force-cache' });
      total[i] = Number(resp.headers.get('content-length')) || 0;
      if (!resp.body || !resp.body.getReader) {
        await resp.arrayBuffer();
        loaded[i] = total[i] = total[i] || EST;
        report();
        return;
      }
      const reader = resp.body.getReader();
      for (;;) {
        const { done, value } = await reader.read(); // eslint-disable-line no-await-in-loop
        if (done) break;
        loaded[i] += value.length;
        if (!total[i]) total[i] = loaded[i]; // нет Content-Length → растёт по факту
        report();
      }
      total[i] = total[i] || loaded[i] || EST;
      loaded[i] = total[i];
      report();
    } catch (e) {
      total[i] = loaded[i] = EST; // ошибка сети — не блокируем полосу
      report();
    }
  }));
  if (onProgress) onProgress(1);
}
